// extracted by mini-css-extract-plugin
export default {"wrapper":"ProgressBar_wrapper__hLZEJ"};